module.exports = __webpack_public_path__ + "img/amex.3cc3f841.svg";